import BaseApi from '@/api/Base/BaseApi'
import { LoginResponse } from '@/api/User/types'

const ROOT = '/cbtp'

export default class CbtpApi extends BaseApi {
  /** 일회용 SSO code를 DAISY JWT로 교환 — 응답 구조는 /user/sign-in과 동일 */
  exchangeSsoCode(code: string) {
    return this.agent.post<LoginResponse>(`${ROOT}/auth/exchange`, { code })
  }
}
